import { render, staticRenderFns } from "./IMOHistory.vue?vue&type=template&id=058c2142&scoped=true&"
import script from "./IMOHistory.vue?vue&type=script&lang=js&"
export * from "./IMOHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c2142",
  null
  
)

export default component.exports